import styled from 'styled-components'

import { THEME } from '../../styles'

const Styled = styled.div`
  display: flex;
  flex-flow: row nowrap;
  border-top: 0.1rem dashed ${THEME.COLORS.foreground.tertiary};
  align-items: center;
  width: 100%;
`
Styled.item = styled.div`
  border-right: 0.1rem dashed ${THEME.COLORS.foreground.tertiary};
  flex-grow: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.8rem;

  ${({ href }) =>
    href
      ? `
      user-select: none;
      text-decoration: none;
      cursor: pointer;
    `
      : ''}
  &:last-child {
    border-right: 0;
  }
`

Styled.score = styled.img`
  height: 3.6rem;
  width: auto;
  object-fit: contain;
`

export default Styled
